$.namespace("SCS.devicelist");

SCS.devicelist.initialized = false;

SCS.devicelist.init = function() {
	
	if(SCS.devicelist.initialized){
		return;
	}
	
	$(document).ready(function() {
		lazy(".devicelisting img");
		load(1000);
		$('.devicelisting a span.img').each(function(){
			var spanWidth = 109;
			var deviceImage = $(this).children('img');
			
			if(deviceImage){
				var imgWidth = deviceImage.width();	
				leftVal=(spanWidth-imgWidth)/2+"px";
				deviceImage.css("left",leftVal);
			}
		});
		SCS.devicelist.initialized = true;
	});
	
	$(window).on('load', function() {
		var timeout = setTimeout(function() {
			$(".devicelisting img").trigger("sporty")
		}, 500);
	});
	
	function lazy(toload) {
		$(toload).lazyload( {
			placeholder : "/etc/designs/help/resources/images/grey.gif",
			event : "sporty"
		});
	}
	
	function load(timeValue) {
		$('li.ui-state-default a').on('click', function() {
		var timeout = setTimeout(function() {
			lazy(".devicelisting img[src$='grey.gif']");
			$(".devicelisting img[src$='grey.gif']").each(function(){
				$(this).trigger("sporty");
			});
			$('.devicelisting a span.img').each(function(){
				var spanWidth = 109;
				var deviceImage = $(this).children('img');
				if(deviceImage){
					var imgWidth = deviceImage.width();	
					leftVal=(spanWidth-imgWidth)/2+"px";
					deviceImage.css("left",leftVal);
				}
			});
		}, timeValue);
	});}
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/devicelist.js
// module id = 345
// module chunks = 0